import React from 'react';
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';
import { useTranslation } from 'react-i18next';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useAppSelector } from 'store/hook';

type ConfirmDeleteUserType = {
  isOpen: boolean;
  onCancel: () => void;
  submit: () => void;
};

const ConfirmDeleteUser = ({isOpen, onCancel, submit }: ConfirmDeleteUserType) => {
  const { t } = useTranslation();

  const { selectedUser } = useAppSelector((state) => state.dataUsers);  
  
  return (
    <ConfirmationModal
      isOpen={isOpen}
      onCancel={onCancel}
      submit={submit}
      isLoading={false}
      title={t('Users.confirm.excludeTitle')}
      text={<span>
        <QuestionCircleOutlined style={{ color: 'red', paddingRight: 8 }} />
        <span>{`${t('Users.confirm.confirmUserExclude')}
        ${selectedUser?.first_name} ${selectedUser?.last_name} (${selectedUser?.email})
        ${t('Users.confirm.fromRoom')}`}</span>
      </span>}
      okText={t('Users.confirm.yes')}
      cancelText={t('Users.confirm.cancel')}
      centered={true}
    />
  );
}

export default ConfirmDeleteUser;
